import { useMemo } from 'react';
export default function useDetailTabLabel({
  allowCollapseToOne,
  value,
  filter,
  model
}) {
  return useMemo(() => {
    if (allowCollapseToOne && value) {
      let items = model.types().entries(value);
      if (typeof filter === 'function') {
        items = items.filter(filter);
      }
      return items.length === 1 ? 'Details' : 'Types';
    }
    return 'Types';
  }, [filter, value, allowCollapseToOne, model]);
}